import { FunctionComponent, PropsWithChildren } from 'react';

import { ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';

import { useNavigateToEdit } from '../../../../../../../../shared/hooks/use-navigate-to-edit/use-navigate-to-edit.hook';
import Paper from '../../../../../../../shared/components/ui/Paper';
import Typography from '../../../../../../../shared/components/ui/Typography';
import { CampaignOverviewModel } from '../../../../../../models/campaign-overview.model';
import { calculateExecutedVehiclesPercentage } from '../../utils/calculate-executed-vehicles-percentage/calculate-executed-vehicles-percentage';
import { convertFirmwareNamesToReactElement } from '../../utils/convert-firmware-names-to-react-element/convert-firmware-names-to-react-element.util';
import CampaignCarsExecutionProgressBar from '../campaign-cars-execution-progress-bar/campaign-cars-execution-progress-bar';
import { CampaignCarsExecutionProgressBarTheme } from '../campaign-cars-execution-progress-bar/theme/campaign-cars-execution-progress-bar.theme';
import CampaignDetailsColumn from '../campaign-details-column/campaign-details-column';

const CampaignsDetailsCell: FunctionComponent<
  Omit<CampaignOverviewModel, 'status'>
> = (
  props: PropsWithChildren<Omit<CampaignOverviewModel, 'status'>>
): JSX.Element => {
  const navigate = useNavigateToEdit(props.id);

  return (
    <Box>
      <Typography
        component="h4"
        sx={{
          fontSize: '24px',
          marginBottom: '16px',
          marginTop: '8px',
          fontWeight: 400,
          letterSpacing: 0,
          lineHeight: '28px',
          cursor: 'pointer',
        }}
        onClick={navigate}
      >
        {props.name}
      </Typography>

      <Paper
        sx={{
          boxShadow: 'unset',
          display: 'flex',
          gap: '80px',
        }}
      >
        <CampaignDetailsColumn
          title="Firmware Names"
          content={convertFirmwareNamesToReactElement(props.firmwareNames)}
          key={'Firmware Names' + props.firmwareNames}
        />

        <CampaignDetailsColumn
          title="Brand/Vehicle"
          content={props.brand?.name ?? ''}
          key={'Brand/Vehicle' + props.brand?.name}
        />

        <CampaignDetailsColumn
          title="Model"
          content={props.model?.name ?? ''}
          key={'Model' + props.model?.name}
        />
      </Paper>

      <ThemeProvider theme={CampaignCarsExecutionProgressBarTheme}>
        <Paper className="campaign-cars-execution-progress-bar-container">
          <CampaignCarsExecutionProgressBar
            value={calculateExecutedVehiclesPercentage(
              props.executedVehiclesNumber,
              props.totalVehiclesNumber
            )}
            executedVehiclesNumber={props.executedVehiclesNumber}
            totalVehiclesNumber={props.totalVehiclesNumber}
          />
        </Paper>
      </ThemeProvider>
    </Box>
  );
};

export default CampaignsDetailsCell;
